import React, { Component, PropType } from 'react'
// import DescriptionComponent from '../commonComponents/DescriptionComponent'
import SummaryData from './component/SummaryData';
import { getInitialData, set_property_metric_breakup, remove_property_metric_breakup, get_property_metric_breakup, setInsightFunction, removeFilter } from '../../actions/index'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';

var growthPeriod = [];
var topStyle = { margin: '21px 0px -8px 22px' };
var property,
    propMulti,
    propertyType;

var hStyle = {
    margin: '5% auto',
    textAlign: 'center'
}
class Summary extends React.Component {
    constructor(props) {
        super(props)
        this.state = props;
        if(!this.props.dataSet)
            this.props.getDataSet(this.props.dataSet,props.authData)
        if(!props.selectedMetric)
            this.props.getInitialData(this.props.dataSet, 'summary',props.authData)
        this.drillHandle = this.drillHandle.bind(this);        
    }
    componentWillReceiveProps(nextProps) {
        this.setState(nextProps)
        //when pressed back dont update URL so sending 0 to getmetric
        // this.getMetric(nextProps.data, 0);
    }
    handleChange = (e, type) => {
        if (e == 'property') {
            propertyType = '';
            var sample = '';
            if (type == null) {
                sample = '';
                propMulti = false;
                type = {
                    label: 'Total',
                    value: 'all',
                    type: "propertyLabel"
                };
            } else {
                if (type.length)
                    propMulti = type[type.length - 1].type == 'propertyLabel'
                        ? false
                        : true;
                if (!propMulti) {
                    if (type.length) {
                        sample = type[type.length - 1].value;
                        propMulti = type[type.length - 1].type == 'propertyLabel'
                            ? false
                            : true;
                        type = type[type.length - 1];
                    } else {
                        sample = type.value;
                        propMulti = type.type == 'propertyLabel'
                            ? false
                            : true;
                        type = type;
                    }
                } else {
                    type
                        .forEach(function (data, index) {
                            if (index != 0)
                                sample += "," + data.value;
                            else
                                sample += data.value;
                        }
                        )
                }
                if (type == null) {
                    type = {
                        label: 'Total',
                        value: 'all',
                        type: "propertyLabel"
                    };
                }
            }
            this.setState({ property: sample, propertyDisp: type, Metric: this.state.Metric, metricValue: this.state.metricValue, metricRange: '', point: null });
            //when property is updated then url of just property changes other remains same

            handleurl(sample, this.state.SelectedCategoryValue, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.metricRange, this.state.periodComparison, this.state.outputType, this.state.isInsight);
        } else if (e == 'propertyValue') {
            this.setState({ SelectedCategoryValue: type, question: null, questionId: '', metricRange: '' });
            // when propertyvalue is updated then url of just propertyvalue changes other
            // remains same

            handleurl(this.state.property, type, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.metricRange, this.state.periodComparison, this.state.outputType, this.state.isInsight);
        } else if (e == 'metric') {
            var sampleValue = '';
            type.map(function (innerData, index) {
                if (index != 0)
                    sampleValue += "," + innerData.value;
                else
                    sampleValue = innerData.value;
            }
            )
            this.setState({ selectedMetric: sampleValue, selectedMetricDisp: type, question: null, questionId: '', metricRange: '', point: null });
            //when metric is updated then url of just metric changes other remains same

            handleurl(this.state.property, this.state.SelectedCategoryValue, sampleValue, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, '', this.state.periodComparison, this.state.outputType, this.state.isInsight);
        } else if (e == 'metricDisp') {
            this.setState({ selectedMetricDisp: type });
            //when metric is updated then url of just metric changes other remains same
        } else if (e == 'breakup') {
            var sample = '';
            if (type != null) {
                type
                    .forEach(function (data, index) {
                        if (index != 0)
                            sample += "," + data.value;
                        else
                            sample += data.value;
                    }
                    )
            } else
                sample = null;
            this.setState({ SelectedBreakUp: sample, SelectedBreakUpDisp: type, question: null, questionId: '', metricRange: '', point: null });
            //when breakup is updated then url of just breakup changes other remains same

            handleurl(this.state.property, this.state.SelectedCategoryValue, this.state.selectedMetric, sample, this.state.startDate, this.state.endDate, this.state.metricRange, this.state.periodComparison, this.state.outputType, this.state.isInsight);
        } else if (e == 'growth') {
            this.setState({ periodComparison: type, question: null, questionId: '', metricRange: '', point: null });
            // when propertyvalue is updated then url of just propertyvalue changes other
            // remains same
            handleurl(this.state.property, this.state.SelectedCategoryValue, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.metricRange, type, this.state.outputType, this.state.isInsight);
        } else {
            var dropdownConfig = updatePeriodComparisonDropdown(this.state.periodComparison, e, type);
            growthPeriod = dropdownConfig['growthPeriod'];
            var periodComparison = dropdownConfig['periodComparison'];
            this.setState({ startDate: e, endDate: type, question: null, metricRange: '', periodComparison: periodComparison, point: null });
            handleurl(this.state.property, this.state.SelectedCategoryValue, this.state.selectedMetric, this.state.SelectedBreakUp, e, type, this.state.metricRange, periodComparison, this.state.outputType, this.state.isInsight);
        }
    }
    handleDownload = (e, type) => {
        var url = '/dashboard/summary/getsummary';
        var summaryData = this.state;
        url += '?startDate=' + summaryData.startDate + "&endDate=" + summaryData.endDate + "&selectedProperty=" + summaryData.property + "&selectedPropertyValue=" + summaryData.SelectedCategoryValue + "&selectedMetric=" + summaryData.selectedMetric + "&breakUp=" + summaryData.SelectedBreakUp + '&download=true&metricRange=' + summaryData.metricRange + "&periodComparison" + summaryData.periodComparison + "&outputType=" + summaryData.outputType;
        var win = window.open(url, '_blank');
        win.focus();
    }
    componentWillMount() {
        //this is used when the app is rendered first time
        // this.getMetric(this.state, 1);
    }
    getMetric = (data, updateStatus) => {
        var that = this;
        //Check this
        var pinHandleFunction = this.pinHandle;
        var startDate = moment(decodeURIComponent(data.startDate), dateFormatToSend1).isValid() ? decodeURIComponent(data.startDate) : minDateCalendar;
        var endDate = moment(decodeURIComponent(data.endDate), dateFormatToSend2).isValid() ? decodeURIComponent(data.endDate) : maxDateCalendar;
        var localGrowthPeriod = getGrowthPeriod(startDate, endDate);
        var calculatedGrowthPeriod = localGrowthPeriod[1];
        growthPeriod = localGrowthPeriod[0];
        var newPeriodComparison = '0';
        if (calculatedGrowthPeriod <= data.periodComparison)     // if calculated periodComparison is same as set by user in db then set that
            newPeriodComparison = data.periodComparison;
        data.periodComparison = newPeriodComparison;       // else if it's something else then set previous period. No smart periodComparison setting here
        //set the values with inital data values
        that.setState({
            Breakup: null,
            SelectedBreakUp: decodeURIComponent(data.SelectedBreakUp),
            Metric: metricGlobal,
            SelectedCategoryValue: null,
            Category: null,
            CategoryValue: null,
            property: decodeURIComponent(data.property),
            updateChange: 1,
            periodComparison: data.periodComparison,
            outputType: data.outputType,
            isInsight: data.isInsight,
            startDate: startDate,
            endDate: endDate
        });
        jQuery.ajax({
            type: 'Get',
            data: 'property=' + encodeURIComponent(decodeURIComponent(data.property)) + "&filter=" + encodeURIComponent(decodeURIComponent(data.SelectedBreakUp)),
            url: '/dashboard/summary/getmetric',
            success: function (response) {
                response = decodeResponseBody(response)
                checkIfSessionTimedOut(response)
                var reportData = jQuery.parseJSON(response.savedReport);
                response = jQuery.parseJSON(response.data);
                main_property_array = jQuery.parseJSON(response.property);
                metricGlobal = jQuery.parseJSON(response.metric);
                metricGlobal = modifyMetricGlobal(metricGlobal, 'summary', false);
                dashboard_options = response.dashboard;
                // metricGlobal.push({"label":"Count","value":"count","metricUnit":"","metricPrefix":"","metricUnitHTML":"","type":"1","roundOff":"0","metricType":"number","sort":null,"sortOrder":null,"isDerived":"0","defaultFormula":""});
                metricFunction = jQuery.parseJSON(response.metricFunction);
                metricPossibleCombinations = createCombination(metricGlobal, metricFunction);
                var sample = null, propertyMain = null, propertyNew = decodeURIComponent(data.property);
                if (that.state.SelectedBreakUp && that.state.SelectedBreakUp != 'undefined')
                    sample = jQuery.parseJSON(reportData.filter);
                if (that.state.property && that.state.property != 'undefined') {
                    propertyMain = jQuery.parseJSON(reportData.property);
                    propMulti = propertyMain[propertyMain.length - 1].type == 'propertyLabel'
                        ? false
                        : true;
                    if (!propMulti)
                        propertyMain = propertyMain[0]
                } else {
                    // If default property is property value then set it otherwise set Total
                    if (decodeURIComponent(data.property) != 'null' && JSON.parse(reportData.property)[0].type == 'propertyValue' && decodeURIComponent(that.state.question) == "") {
                        propertyMain = jQuery.parseJSON(reportData.property);
                        propertyNew = jQuery.parseJSON(reportData.property)[0].value;
                    } else {
                        propertyMain = { label: 'Total', value: 'all', type: "propertyLabel" };
                    }
                }
                var selectedMetric = decodeURIComponent(data.selectedMetric) == '' || decodeURIComponent(data.selectedMetric) == 'null'
                    ? jQuery.parseJSON(reportData.chartValues)[0].metrics
                    : decodeURIComponent(data.selectedMetric);
                // var selectedMetric = decodeURIComponent(data.selectedMetric).split(',');
                var selectedMetricDisp = [];
                selectedMetricDisp = metricDataToDisp(metricGlobal, metricFunction, selectedMetric);
                var metricRange = that.props && that.props.data ? that.props.data.metricRange : '';
                property_current_index = null;
                main_property_array.map(function (property, index) {
                    if (property.value == that.state.property) {
                        property_current_index = index;
                    }
                })

                that.setState({
                    Breakup: null,
                    SelectedBreakUpDisp: sample,
                    SelectedBreakUp: that.state.SelectedBreakUp,
                    Metric: metricGlobal,
                    selectedMetric: selectedMetric,
                    selectedMetricDisp: selectedMetricDisp,
                    metricRange: metricRange,
                    SelectedCategoryValue: null,
                    Category: null,
                    CategoryValue: null,
                    property: propertyNew,
                    propertyDisp: propertyMain,
                    updateChange: 1,
                    periodComparison: that.state.periodComparison,
                    outputType: that.state.outputType,
                    isInsight: that.state.isInsight
                });
                if (updateStatus) { //when initial load then only set the url else back handles everything

                    handleurl(that.state.property, that.state.SelectedCategoryValue, selectedMetric, that.state.SelectedBreakUp, moment(decodeURIComponent(data.startDate), dateFormatToSend1).isValid()
                        ? decodeURIComponent(data.startDate)
                        : minDateCalendar, moment(decodeURIComponent(data.endDate), dateFormatToSend2).isValid()
                            ? decodeURIComponent(data.endDate)
                            : maxDateCalendar, metricRange, data.periodComparison, data.outputType, data.isInsight);
                }
            }
        });
    }
    drillHandle = (demoVar, type=null, event) => {
        if (event == 'insight') {
            // if(!openInsightNewTab) {
                defaultFilterFlag = '0'
                this.props.removeFilter()
            // } 
                       
            this.props.setInsightFunction({"point": demoVar, pointMetric: demoVar, "insight": true, 'deepInsight': false, insightMetric: null});            
            // this.setState({ point: demoVar });
            // this.refs.sidebarInsightRef.handleInsightEnable(true);

            // closeSidebar('FilterDiv');
        }
        else if (event == 'deepInsight') {
            defaultFilterFlag = '0'
            this.props.removeFilter()
            this.props.setInsightFunction({"point": demoVar, pointMetric: demoVar, "insight": false, 'deepInsight': true, insightMetric: BaseInsightMetric});
            // this.setState({ point: demoVar });
            // this.refs.sidebarInsightRef.handleInsightEnable(true);

            // closeSidebar('FilterDiv');
        }
    }
    pinHandle = (title, dashboard_id, dashboard_value, dashboard_time_range) => {
        var data = {};
        if (dashboard_time_range) {
            dashboard_time_range = dashboard_time_range.split("_");
            data.startDate = "{'date_method':'endDate','count':" + (dashboard_time_range[0] - 1) + ",'date_format':'" + dashboard_time_range[1] + "'}";
            data.endDate = "{'date_method':'endDate'}";
        } else {
            data.startDate = this.state.startDate;
            data.endDate = this.state.endDate;
        }
        data.category = this.state.property;
        data.categoryValue = this.state.SelectedCategoryValue;
        data.breakUp = this.state.SelectedBreakUp;
        data.selectedMetric = pin_metric_value;
        data.calculateGrowth = this.state.calculateGrowth;
        data.outputType = this.state.outputType;
        data.isInsight = this.state.isInsight;
        data.startDateDisp = this.state.startDateDisp;
        data.endDateDisp = this.state.endDateDisp;
        data.selectedMetricDisp = pin_metric_object;
        data.periodComparison = this.state.periodComparison;
        let url = "/dashboard/summary/pin";
        var fd = new FormData();
        fd.append('parameter', JSON.stringify(data));
        fd.append('componentType', 'Summary');
        fd.append('pin_title', title);
        fd.append('pin_value', dashboard_value);
        fd.append('pin_id', dashboard_id);
        fd = encodePostBody(fd)
        jQuery.ajax({
            type: 'POST',
            url: '/dashboard/summary/pin',
            data: fd,
            contentType: false,
            processData: false,
            success: function (response) {
                response = decodeResponseBody(response)
                checkIfSessionTimedOut(response)
                alert('Successfully Pinned.');
            }.bind(this)
        });
        CallAPI("POST",url,fd,null, function (response) {
                    checkIfSessionTimedOut(response)
                    alert('Successfully Pinned.');
                },this.props.authData)
    }
    updateMetricRange = (metricRange) => {
        this.setState({ metricRange: metricRange });

        handleurl(this.state.property, this.state.SelectedCategoryValue, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, metricRange, periodComparison, outputType, this.state.isInsight);
    }
    enablePageDescription = (enableDescription) => {    // make insightDate and insightPoint as a null to show page level description
        this.setState({ enableDescription: enableDescription, insightDate: null, insightPoint: null });
    }
    componentDidUpdate = () => {
        jQuery(".active").removeClass("active");
        jQuery("#liSummary").addClass("active");
        if (filter_enabled === "1") {
            if (jQuery(window).width() >= mobile_width) {
                openSidebar('FilterDiv', filter_desktop_width);
                document.getElementById('main-content').style.marginRight = main_content_div_filter;
            } else openSidebar('FilterDiv', filter_mobile_width);
        }
    }
    render() {
        if (!this.state.selectedMetric || metricGlobal.length==0 || metricFunction==0) {
            return null;
        }

        var periodComparison = this.state.periodComparison;
        periodComparison = periodComparison ? periodComparison : this.props.periodComparison;
        // var qstring = "?property=" + this.state.property + "&propertyValues=" + this.state.SelectedCategoryValue + "&selectedMetric=" + this.state.selectedMetric + "&breakup=" + this.state.SelectedBreakUp + "&startDate=" + this.state.startDate + "&endDate=" + this.state.endDate + "&metricRange=" + this.state.metricRange + '&periodComparison=' + periodComparison + '&outputType=' + this.state.outputType + '&isInsight=' + this.state.isInsight + "&toolId=" + mainToolId;
        if (this.props.metricDisp)
            var labelShow = getLabel(this.props.metricDisp, this.state.selectedMetric, this.props.propertyDisp, this.props.SelectedBreakUpDisp, null, null, this.props.includeDisp, this.props.excludeDisp);
        else
            var labelShow = {
                'metricText': null,
                'propertyText': null,
                'breakupText': null
            };
        
        // var descriptionComponentVariabele = null
        // if ((this.props.enableDescription || this.props.insightPoint || voiceQuestion == "1") && metricGlobal) {
        // // if ((this.props.enableDescription || voiceQuestion == "1")) {
        //     let period = this.state.period;
        //     period = period ? period : (this.state.insightDate ? this.state.chartType : '');    // Set the period only when date is set
        //     descriptionComponentVariabele = <DescriptionComponent ref='descriptionRef' authData={this.props.authData} selectedMetric={decodeURIComponent(this.state.insightMetric ? this.state.insightMetric : this.state.selectedMetric)} chartCat={'Bar'} period={period} startDate={this.props.startDate} endDate={this.props.endDate} category={this.state.property} breakUp={this.state.SelectedBreakUp} include={this.props.include} exclude={this.props.exclude} metricRange = {this.state.metricRange} date={this.props.insightDate} point={this.props.insightPoint} enableDescription={this.props.enableDescription}/>            
        // }

        return (
            <div id="main-content">
                <div className='divSelect'>
                    <SummaryData
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        drillHandle={drillHandleFunction}
                        category={this.state.property}
                        categoryValue={this.state.SelectedCategoryValue}
                        metric={this.state.metricValue}
                        breakUp={Array.isArray(this.state.SelectedBreakUp) ? this.state.SelectedBreakUp.join() : this.state.SelectedBreakUp}
                        include={this.props.include === 'undefined' ? '' : this.props.include}
                        exclude={this.props.exclude === 'undefined' ? '' : this.props.exclude}                        
                        selectedMetric={this.state.selectedMetric}
                        handleChange={this.handleChange}
                        selectedMetricDisp={this.state.selectedMetricDisp}
                        metricRange={this.state.metricRange}
                        periodComparison={this.state.periodComparison}
                        outputType={this.state.outputType}
                        isInsight={this.state.isInsight}
                        metricGlobal={metricGlobal}
                        metricFunction={metricFunction}
                        metricText={labelShow.metricText}
                        propertyText={labelShow.propertyText}
                        breakupText={labelShow.breakupText}
                        includeText={labelShow.includeText}
                        excludeText={labelShow.excludeText}
                        insightPoint={this.state.point}
                        authData={this.props.authData}
                        pinFilter={true}
                        dataSet={this.props.dataSet}
                        pageError={this.props.pageError}
                        insight={this.props.insight}
                        globalFilters={this.props.globalFilters}
                        sortMetric={this.props.sortMetric}
                        cagrPoint={this.props.cagrPoint}
                        removeGlobalFilter={this.props.removeGlobalFilter}
                        ytdcagr={this.props.ytdcagr}
                        prevStartDate={this.props?.prevStartDate}
                        prevEndDate={this.props?.prevEndDate}

                    />
                    {/* {descriptionComponentVariabele} */}
                </div>
            </div>
        );
    }
};

function mapStateToProps(state) {
    var initial_data_from_url = {};
    initial_data_from_url = getURLDataHandle();

    let finalObj = stateToPropsHandle(initial_data_from_url, state)
    return finalObj
    
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInitialData, remove_property_metric_breakup, set_property_metric_breakup, get_property_metric_breakup, setInsightFunction, removeFilter
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Summary);